import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { service } from '@ember/service';

import type { SafeString } from '@ember/template';
import type { FormatMessageParameters } from 'ember-intl/-private/formatjs';

import type { NamedArgs, PositionalArgs } from 'ember-modifier';
import type LabelService from 'volta/services/label-service';

interface TElseSignature {
  Args: {
    Positional: [
      translation: string | SafeString | undefined,
      fallback?: string | SafeString | undefined
    ];
    Named: FormatMessageParameters[1] & {
      htmlSafe?: boolean;
      locale?: string;
    };
  };
  Return: string | SafeString;
}

export default class TElseHelper extends Helper<TElseSignature> {
  @service labelService!: LabelService;

  // eslint-disable-next-line ember/no-observers
  onLocaleChange = observer('localization.intl.locale', () => {
    this.recompute();
  });

  compute(
    [translation, fallback]: PositionalArgs<TElseSignature>,
    options: NamedArgs<TElseSignature>
  ): string | SafeString {
    if (!translation) {
      return (fallback ?? '') as string | SafeString;
    }
    return this.labelService.tOrElse(translation, fallback, options) as string;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    't-else': typeof TElseHelper;
  }
}
